import api from '../api';

export const CONSENT_COOKIE = 'tx_consent';
export const AID_COOKIE = 'tx_aid';
const STORAGE_KEY = 'tx_consent_cache';

export const CATEGORIES = ['necessary', 'analytics', 'marketing', 'personalization'];

function readCookie(name) {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function readConsentCookie() {
    try {
        const raw = readCookie(CONSENT_COOKIE);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function readFromStorage() {
    try {
        const raw = window.localStorage?.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function writeToStorage(value) {
    try {
        window.localStorage?.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
        /* ignore */
    }
}

export const consentService = {
    /**
     * Local-only quick read: cookie → localStorage. Returns null if neither exists.
     * Used to render the banner/state immediately without waiting for the network.
     */
    getCachedLocal() {
        const cookie = readConsentCookie();
        if (cookie && cookie.c) {
            return {
                policyVersion: cookie.v,
                categories: cookie.c,
                anonymousId: cookie.aid,
                updatedAt: cookie.ts,
                _source: 'cookie',
            };
        }
        return readFromStorage();
    },

    async fetchPolicy() {
        const res = await api.get('/consent/policy/current');
        return res.data || {};
    },

    async fetchMe() {
        const res = await api.get('/consent/me');
        const data = res.data || {};
        writeToStorage(data);
        return data;
    },

    async save({ categories, source = 'preference_center', locale, policyVersion }) {
        const res = await api.post('/consent', { categories, source, locale, policyVersion });
        const data = res.data || {};
        writeToStorage(data);
        return data;
    },

    async withdraw() {
        const res = await api.post('/consent/withdraw');
        const data = res.data || {};
        writeToStorage(data);
        return data;
    },

    /** Helpers */
    defaults() {
        return { necessary: true, analytics: false, marketing: false, personalization: false };
    },

    acceptAll() {
        return { necessary: true, analytics: true, marketing: true, personalization: true };
    },

    rejectAll() {
        return this.defaults();
    },
};

export default consentService;
